import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useFetch } from '../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import {
  Container,
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  Divider,
} from '@mui/material/';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SelectStudent from '../../../components/SelectStudent';
import SelectAvailableExamSession from '../../../components/SelectAvailableExamSession';
import { NumericFormat } from 'react-number-format';
import SendIcon from '@mui/icons-material/Send';
import SelectedStudent from '../../../components/SelectedStudent';
import CircularProgress from '@mui/material/CircularProgress';
import { orderBy } from 'firebase/firestore';
import ViewAuthList from '../../../components/cambridge/ViewAuthList';
import ViewTerms from '../../../components/cambridge/ViewTerms';
import ViewQuote from '../../../components/cambridge/ViewQuote';
import SelectVenue from '../.././../components/SelectVenue';
import CancelIcon from '@mui/icons-material/Cancel';
import OrderTotal from '../../../components/cambridge/OrderTotal';
import { ElectricScooterSharp } from '@mui/icons-material';
import SelectCambridgeExamSession from '../../../components/SelectCambridgeExamSession';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddNewParent from '../../../components/cambridge/AddNewParent';
function CamApply() {
  document.title =
    'Private Candidates Online: Cambridge Assessment Application ';

  const [sessionActive, setSessionActive] = useState(0);
  const { user, studentID } = useAuthContext();
  const [addParent, setAddParent] = useState(0);
  const [studentId, setStudentId] = useState(studentID);
  const [campusId, setCampusId] = useState(6);
  const [sessionId, setSessionId] = useState('');
  const [venueId, setVenueId] = useState(null);
  const [academicYear, setAcademicYear] = useState(new Date().getUTCFullYear());

  const {
    getData,
    error: error4,
    data: activeSessions,
    isPending: isPending4,
  } = useFetch(`https://pcapi.bi-oss.co.za/sessioninfo/activecount`);
  const {
    postData: checkAccountStatus,
    errorMessage: errorMessage6,
    error: error6,
    data: accountVerified,
    isPending: isPending6,
  } = useFetch(
    `https://pcapi.bi-oss.co.za/student/verifyaccount/${studentID}`,
    'POST',
  );
  const {
    postData: postData2,
    error: error2,
    data: studentAge,
    isPending: isPending2,
  } = useFetch(
    `https://pcapi.bi-oss.co.za/student/getage/${studentID}`,
    'POST',
  );
  const {
    postData: paymentPersonCheckerror,
    error3,
    data: paymentPersonResponse,
    isPending: isPending3,
  } = useFetch(
    `https://pcapi.bi-oss.co.za/student/paymentpersoncheck/${studentID}`,
    'POST',
  );
  const {
    postData,
    error,
    data: venueData,
    isPending: isPendingVenue,
  } = useFetch('https://pcapi.bi-oss.co.za/studcambridge/checkvenue', 'POST');

  const {
    postData: updateCurrentAuth,
    error: error5,
    data: currentAuthUpdated,
    isPending: isPending5,
  } = useFetch(
    'https://pcapi.bi-oss.co.za/studcambridge/updatecurrentauth',
    'POST',
  );

  useEffect(() => {
    if (activeSessions) {
      if (activeSessions.sessionCount === 0) {
        setSessionActive(2);

        checkAccountStatus();
      }
      if (activeSessions.sessionCount > 0) {
        setSessionActive(1);
        checkAccountStatus();
      }
    }
  }, [activeSessions]);

  useEffect(() => {
    if (accountVerified) {
      postData2();
    }
  }, [accountVerified]);

  useEffect(() => {
    if (studentAge) {
      if (studentAge.age > 17) {
        setStartEntry(1);
        postData({
          studentId,
          sessionId,
          campusId,
          academicYear,
        });
      }

      if (studentAge.age <= 17) {
        paymentPersonCheckerror();
      }
    }
  }, [studentAge]);

  useEffect(() => {
    if (paymentPersonResponse) {
      if (paymentPersonResponse.parentCount === 0) {
        setAddParent(1);
      }
      if (paymentPersonResponse.parentCount === 1) {
        setStartEntry(1);
        postData({
          studentId,
          sessionId,
          campusId,
          academicYear,
        });
      }
    }
  }, [paymentPersonResponse]);

  useEffect(() => {
    if (new Date().getMonth() >= 4) {
      setSessionId(2);
    }
    if (new Date().getMonth() < 4) {
      setSessionId(1);
    }
  }, [new Date().getMonth()]);

  const [startEntry, setStartEntry] = useState(0);
  const [viewVenueSelect, setViewVenueSelect] = useState(0);
  const [viewExams, setViewExams] = useState(0);
  const [viewTerms, setViewTerms] = useState(0);
  const [viewQuote, setViewQuote] = useState(0);
  const [viewOrder, setViewOrder] = useState(0);

  const navigate = useNavigate();
  const [process, setProcess] = useState(0);

  const [payReqId, setPayReqId] = useState('');
  const [returnChecksum, setReturnChecksum] = useState('');

  const handleSubmit1 = (e) => {
    e.preventDefault();

    //update venue and stuff here
    updateCurrentAuth({
      studentId,
      sessionId,
      createdBy: user.email,
      venueId,
    });
    //  setViewExams(1)
  };

  useEffect(() => {
    if (currentAuthUpdated) {
      setViewExams(1);
    }
  }, [currentAuthUpdated]);

  useEffect(() => {
    if (venueData) {
      if (venueData.length > 0) {
        venueData.map((data) => {
          setViewVenueSelect(2);
          setVenueId(data.venueId);
        });
      }
      if (venueData.length === 0) {
        setViewVenueSelect(1);
      }
    }
  }, [venueData]);

  const handleParentLinked = (e) => {
    setAddParent(0);
    getData();
  };
  useEffect(() => {
    if (sessionId) {
      postData({
        studentId,
        sessionId,
        campusId,
        academicYear,
      });
    }
  }, [sessionId]);

  return (
    <>
      {sessionActive === 2 && !addParent && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="h3"
                    component="h3"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    External Assessment Application
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="error.main"
                    sx={{ textAlign: 'center' }}
                  >
                    There are currently no active examination sessions. Please
                    come back at a later stage.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={(e) => navigate('/cambridge')}
                      >
                        Dashboard <DashboardIcon />
                      </Button>
                    </Box>
                  </Grid>
                </Box>

                <Box mb={5} />
              </Grid>
            </Grid>
          </Container>
        </>
      )}

      {isPending6 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Verifying candidate account status...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      {isPending4 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Verifying session data...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      {isPending2 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Verifying candidate info...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}
      {isPending3 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'primary.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="primary.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Verifying parent or guardian info...
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <CircularProgress />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </>
      )}

      {startEntry === 1 &&
        sessionActive === 1 &&
        !viewExams &&
        !viewTerms &&
        !viewQuote &&
        !viewOrder &&
        !addParent && (
          <form onSubmit={handleSubmit1}>
            <Container maxWidth="md">
              <Box mb={5} />
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
                sx={{
                  border: 'solid',
                  borderWidth: '3px',
                  borderColor: 'primary.main',
                  borderRadius: 2,
                }}
              >
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="h3"
                      component="h3"
                      color="primary.main"
                      sx={{ textAlign: 'center' }}
                    >
                      External Assessment Application
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="p"
                      color="primary.main"
                      sx={{ textAlign: 'center' }}
                    >
                      Parents or Guardians are able to process a student’s
                      Cambridge External Assessment entry via this portal. To
                      process an entry, select the student you wish to enter,
                      confirm their examination entries and complete the online
                      payment. Once payment is complete, British International
                      Colleges and Schools will process the student’s
                      application with Cambridge on your behalf.
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <SelectAvailableExamSession
                      sessionId={sessionId}
                      setSessionId={setSessionId}
                      camOnly={1}
                    />
                  </Box>
                </Grid>

                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    {viewVenueSelect === 1 && !isPendingVenue && (
                      <SelectVenue venueId={venueId} setVenueId={setVenueId} />
                    )}
                    {viewVenueSelect === 2 && !isPendingVenue && (
                      <SelectVenue
                        venueId={venueId}
                        setVenueId={setVenueId}
                        disabled={1}
                      />
                    )}
                    {isPendingVenue && (
                      <Typography variant="h6" component="h3" color="secondary">
                        <CircularProgress />
                        Checking Venue....
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Typography variant="body2" component="p" color="primary">
                      Only one venue can be selected as the writing location per
                      examination session.
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        {campusId &&
                          studentId &&
                          !isPendingVenue &&
                          !isPending5 && (
                            <Button
                              fullWidth
                              type="submit"
                              color="primary"
                              variant="contained"
                            >
                              Continue
                              <SendIcon />
                            </Button>
                          )}
                        {(!campusId || !studentId || isPendingVenue) && (
                          <Button
                            fullWidth
                            disabled
                            color="primary"
                            variant="contained"
                          >
                            Continue
                            <SendIcon />
                          </Button>
                        )}

                        {isPending5 && (
                          <Button
                            fullWidth
                            disabled
                            color="primary"
                            variant="contained"
                          >
                            Continue
                            <CircularProgress />
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Box>
                  <Box mb={5} />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                      maxWidth: '95%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }}
                  >
                    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                          maxWidth: '95%',
                          marginLeft: 'auto',
                          marginRight: 'auto',
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={(e) => navigate('/cambridge')}
                        >
                          <ArrowBackIcon /> Back
                        </Button>
                      </Box>
                    </Grid>
                  </Box>

                  <Box mb={5} />
                </Grid>
              </Grid>
            </Container>
          </form>
        )}

      {viewExams === 1 && (
        <ViewAuthList
          venueId={venueId}
          academicYear={academicYear}
          sessionId={sessionId}
          studentId={studentId}
          campusId={campusId}
          setViewExams={setViewExams}
          setViewTerms={setViewTerms}
        />
      )}

      {viewTerms === 1 && (
        <ViewTerms
          academicYear={academicYear}
          sessionId={sessionId}
          studentId={studentId}
          campusId={6}
          setViewQuote={setViewQuote}
          setViewTerms={setViewTerms}
          setViewExams={setViewExams}
        />
      )}

      {viewQuote === 1 && (
        <ViewQuote
          academicYear={academicYear}
          sessionId={sessionId}
          venueId={venueId}
          studentId={studentId}
          campusId={campusId}
          setViewQuote={setViewQuote}
          setViewTerms={setViewTerms}
          setViewExams={setViewExams}
          setViewOrder={setViewOrder}
        />
      )}

      {viewOrder === 1 && (
        <OrderTotal
          academicYear={academicYear}
          sessionId={sessionId}
          studentId={studentId}
          campusId={campusId}
          setViewQuote={setViewQuote}
          setViewOrder={setViewOrder}
          venueId={venueId}
        />
      )}

      {addParent === 1 && (
        <AddNewParent
          studentId={studentID}
          handleParentLinked={handleParentLinked}
        />
      )}

      {errorMessage6 && (
        <>
          <Container maxWidth="md">
            <Box mb={5} />
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}
              sx={{
                border: 'solid',
                borderWidth: '3px',
                borderColor: 'error.main',
                borderRadius: 2,
              }}
            >
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="h3"
                    component="h3"
                    color="error.main"
                    sx={{ textAlign: 'center' }}
                  >
                    Account Locked
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Typography
                    variant="body2"
                    component="p"
                    color="error.main"
                    sx={{ textAlign: 'center' }}
                  >
                    There is a problem with the candidates account status.
                    Please have the account holder contact the Bursar on{' '}
                    <a href="tel:0117067775">Tel: +27 11 706-7775</a> or via{' '}
                    <a href="mailto:bursar@bicollege.co.za">
                      Email: bursar@bicollege.co.za
                    </a>{' '}
                    .
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    maxWidth: '95%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                >
                  <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: '95%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={(e) => navigate('/cambridge')}
                      >
                        Dashboard <DashboardIcon />
                      </Button>
                    </Box>
                  </Grid>
                </Box>

                <Box mb={5} />
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </>
  );
}

export default CamApply;
